import React, { useState } from 'react';
import { HashRouter, Routes, Route, useNavigate, useSearchParams } from 'react-router-dom';
import WelcomeGuide from './components/WelcomeGuide';
import ProfileGeneration from './components/ProfileGeneration';
import ChatInterface from './components/ChatInterface';
import ChatInterfaceB from './components/ChatInterfaceB';
import ChatInterfaceC from './components/ChatInterfaceC';
import RiskInfoPage from './components/RiskInfoPage';
import AllTrendsPage from './components/AllTrendsPage';
import SystemDetailPage from './components/SystemDetailPage';
import './App.css';

type Version = 'A' | 'B' | 'C';
type RiskType = 'ascvd' | 'tumor';

// 主应用路由组件
function AppRoutes() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [version, setVersion] = useState<Version>('A');

  const handleNextStep = () => {
    navigate('/generation');
  };

  const handleGenerationComplete = () => {
    navigate('/chat');
  };

  const handleRiskInfoOpen = (riskType: RiskType) => {
    navigate(`/risk-info?type=${riskType}`);
  };

  const handleRiskInfoBack = () => {
    navigate('/chat');
  };

  const handleAllTrendsBack = () => {
    navigate('/chat');
  };

  const handleSystemDetailBack = () => {
    navigate('/chat');
  };

  return (
    <div className="app">
      <Routes>
        {/* 欢迎页面 */}
        <Route 
          path="/" 
          element={<WelcomeGuide onNext={handleNextStep} />} 
        />
        
        {/* 档案生成页面 */}
        <Route 
          path="/generation" 
          element={<ProfileGeneration onComplete={handleGenerationComplete} />} 
        />
        
        {/* 聊天界面页面 */}
        <Route 
          path="/chat" 
          element={
            <>
              {/* ABC测试版本切换器 */}
              <div className="ab-test-switcher">
                <button 
                  className={`version-btn ${version === 'A' ? 'active' : ''}`}
                  onClick={() => setVersion('A')}
                >
                  版本A (当前)
                </button>
                <button 
                  className={`version-btn ${version === 'B' ? 'active' : ''}`}
                  onClick={() => setVersion('B')}
                >
                  版本B (测试)
                </button>
                <button 
                  className={`version-btn ${version === 'C' ? 'active' : ''}`}
                  onClick={() => setVersion('C')}
                >
                  版本C (新测试)
                </button>
              </div>
              
              {/* 根据版本显示对应界面 */}
              {version === 'A' && <ChatInterface />}
              {version === 'B' && <ChatInterfaceB onRiskInfoOpen={handleRiskInfoOpen} />}
              {version === 'C' && <ChatInterfaceC onRiskInfoOpen={handleRiskInfoOpen} />}
            </>
          } 
        />
        
        {/* 风险信息页面 */}
        <Route 
          path="/risk-info" 
          element={
            <RiskInfoPage
              riskType={(searchParams.get('type') as RiskType) || 'ascvd'}
              onBack={handleRiskInfoBack}
            />
          } 
        />
        
        {/* 全部指标趋势页面 */}
        <Route 
          path="/all-trends" 
          element={<AllTrendsPage onBack={handleAllTrendsBack} />} 
        />
        
        {/* 系统详情页面 */}
        <Route 
          path="/system/:systemId" 
          element={<SystemDetailPage onBack={handleSystemDetailBack} />} 
        />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <HashRouter>
      <AppRoutes />
    </HashRouter>
  );
}

export default App;